import { Button, Menu, MenuItem, ListItemText, ListItemIcon, SxProps } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CircleIcon from '@mui/icons-material/Circle';
import React, { useState } from 'react';
import { ReportDatabase } from '../../aceapi/aceSchemas';

const getTabStyle = (isActive: boolean): SxProps => ({
    color: 'inherit',
    textTransform: 'none',
    minWidth: 'auto',
    px: 2,
    borderBottom: isActive ? '2px solid lightblue' : '2px solid transparent',
    borderRadius: 0,
    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
});

interface CategoryDropdownProps {
    category: string;
    sources: ReportDatabase[]; // Expected to be pre-sorted
    activeApp: string | null;
    onSelectApp: (nickname: string) => void;
    disabled: boolean;
    isActive: boolean;
}

export default function CategoryDropdown({
    category,
    sources,
    activeApp,
    onSelectApp,
    disabled,
    isActive,
}: CategoryDropdownProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const activeSource = isActive ? sources.find((s) => s.nickname === activeApp) : null;
    const buttonLabel = activeSource ? `${category} › ${activeSource.nickname}` : category;

    const handleSelect = (nickname: string) => {
        onSelectApp(nickname);
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                onClick={(e) => setAnchorEl(e.currentTarget)}
                disabled={disabled}
                endIcon={<ArrowDropDownIcon />}
                sx={getTabStyle(isActive)}
            >
                {buttonLabel}
            </Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                {sources.map((source) => (
                    <MenuItem
                        key={source.id}
                        onClick={() => handleSelect(source.nickname)}
                        selected={source.nickname === activeApp}
                    >
                        <ListItemIcon>
                            <CircleIcon sx={{ fontSize: 12, color: source.color ?? '#376092' }} />
                        </ListItemIcon>
                        <ListItemText>{source.nickname}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
